import { ApiError } from 'src/api/generated';

/**
 * Identifies the retryable conversation conflict already explained by the mutation hook.
 * @param error - Rejected mutation error.
 * @returns Whether callers should retain the conflict-specific retry warning.
 */
export const isConversationOperationConflict = (error: unknown): boolean => {
  const body: unknown = error instanceof ApiError ? error.body : undefined;
  return (
    error instanceof ApiError &&
    error.status === 409 &&
    body !== null &&
    typeof body === 'object' &&
    'details' in body &&
    body.details !== null &&
    typeof body.details === 'object' &&
    'code' in body.details &&
    body.details.code === 'CONVERSATION_OPERATION_CONFLICT'
  );
};
